import React from 'react';
import { Modal } from 'react-bootstrap';
import './terms.css';

const Terms = props => {
  const { show, onHide } = props;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        Términos y condiciones Depósitos a Plazo a través de Internet
      </Modal.Header>
      <Modal.Body className="dap_terms-modal">
        <p>
          Todos los depósitos serán extendidos en forma nominativa y quedarán en
          custodia electrónica.
          <br></br>Las inversiones en depósitos se realizan con cargo a su cuenta vista Coopeuch.<br></br>
          Monto mínimo de inversión de $20.000 para renovables y $100.000 para fijos.<br></br>
          Plazos de inversión desde 7 a 900 días.<br></br>
          Para el depósito a plazo fijo online, el abono se realiza el
          día del vencimiento automáticamente a la cuenta vista Coopeuch.<br></br>
          Los Depósitos Renovables se podrán cobrar a partir del vencimiento considerando 4 días hábiles.<br></br>
          Las inversiones que se realicen después de las 18:00 hrs o en días inhábiles bancarios se harán efectivas el día hábil siguiente antes de las 9:00 hrs.<br></br>
          Los depósitos a plazo tomados en Sucursales, también podrán ser cobrados por Internet, siempre y cuando el titular mantenga <strong>Cuenta Vista Coopeuch</strong> vigente.<br></br>
          Los depósitos a plazo renovables tomados en Internet, también podrán ser cobrados en Sucursales.<br></br>
          Para los depósitos renovables, desde las 18:00 hrs. del último día, si el titular no solicita la liquidación, el depósito será renovado automáticamente por el plazo inicial y la tasa vigente del día del vencimiento.<br></br>
          Coopeuch no acepta solicitudes de retiro anticipado de Depósitos a Plazo.<br></br>
          Infórmese sobre la garantía estatal de los depósitos en su cooperativa o en{' '}

          <a
            href="http://www.sbif.cl"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.sbif.cl
          </a>
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default Terms;
